export interface HistoryData {
  no: number;
  _id: string;
  type: string;
  parameter: {
    _id: string;
    parameter: object;
  };
  action: string;
  menu: string;
  status: string;
  responseBody: string;
  error: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface HistoryFilter {
  updatedAt: string[] | null;
  updatedBy: string[] | null;
  action: string[] | null;
}

export interface OptionFilter {
  key: string;
  filter: [];
}

export interface Filter {
  text: string;
  value: string;
}

export const ActionDisplays = [
  {
    key: "create",
    label: "Create",
  },
  {
    key: "update",
    label: "Update",
  },
  {
    key: "delete",
    label: "Delete",
  },
  {
    key: "export_excel",
    label: "Export Excel",
  },
  {
    key: "submit_report",
    label: "Submit Report",
  },
  {
    key: "action_report",
    label: "Action Report",
  },
  {
    key: "approved",
    label: "Approved",
  },
  {
    key: "reject",
    label: "Reject",
  },
  {
    key: "upload_excel",
    label: "Upload Excel",
  },
  {
    key: "upload_excel",
    label: "Upload Excel",
  },
  {
    key: "export_pdf",
    label: "Export Pdf",
  },
];
